module.exports = __webpack_public_path__ + "static/media/IMG_0802_Reduced.c2dedda3.jpg";